import { ERROR_CLIENT_DESTROYED, CLIENT_NOT_READY_FROM_CACHE } from '../../logger/constants';
export function validateIfNotDestroyed(log, readinessManager, method) {
    if (!readinessManager.isDestroyed())
        return true;
    log.error(ERROR_CLIENT_DESTROYED, [method]);
    return false;
}
export function validateIfReadyFromCache(log, readinessManager, method, featureFlagNameOrNames) {
    if (readinessManager.isReadyFromCache())
        return true;
    log.warn(CLIENT_NOT_READY_FROM_CACHE, [method, featureFlagNameOrNames ? " for feature flag " + featureFlagNameOrNames.toString() : '']);
    return false;
}
// Operational means that the SDK is ready to evaluate (not destroyed and ready from cache)
export function validateIfOperational(log, readinessManager, method, featureFlagNameOrNames) {
    return validateIfNotDestroyed(log, readinessManager, method) && validateIfReadyFromCache(log, readinessManager, method, featureFlagNameOrNames);
}
